import UserOption from "../UserOption/UserOption";
import styles from "./NewChat.module.scss";
import {__bot} from "Utils/Bot/Bot";
import { IBotExMessage } from "Utils/Interfaces";


export default function NewChat() {

  return (
    <div className={styles.container}>
      <div className={styles["text-light"]}>{__bot.getAppConfig().welcome}</div>
      
      {
        __bot.getAppConfig().startupGuid.map((botMessage: IBotExMessage, index) => {
          return <UserOption key={index} {...botMessage}></UserOption>
        })
      }

    </div>
  )
}
